import __request__ from "routing/request";
export function getAll() {
  return __request__("GET", "/system/pipelines/connections", null, {}, {
    "Accept": ["application/json"]
  });
}
export function connectStreams(JSONbody) {
  return __request__("POST", "/system/pipelines/connections/to_pipeline", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function connectPipelines(JSONbody) {
  return __request__("POST", "/system/pipelines/connections/to_stream", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function getPipelinesForStream(streamId) {
  return __request__("GET", `/system/pipelines/connections/${streamId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
